import { addToast } from "@heroui/react";
import React, { useEffect, useState } from "react";

const CountDownComponent = ({ date, isSetTime }) => {
  const [timeOffset, setTimeOffset] = useState(null);

  useEffect(() => {
    const fetchRealTime = async () => {
      try {
        const beforeFetch = Date.now();
        const res = await fetch("https://worldtimeapi.org/api/ip");
        const data = await res.json();
        const afterFetch = Date.now();

        const networkDelay = (afterFetch - beforeFetch) / 2;
        const utcTime = new Date(data.utc_datetime).getTime() + networkDelay;
        const offset = utcTime - afterFetch;
        setTimeOffset(offset);
        // addToast({
        //   title: "Info",
        //   description: "Timer synchronized with real UTC time.",
        //   color: "info",
        //   variant: "bordered"
        // });

        console.log(`Time offset: ${offset}ms (${Math.round(offset / 1000)}s)`);
      } catch (e) {
        console.log("Time API failed, using local time", e);
        // addToast({
        //   title: "Warning",
        //   description:
        //     "Unable to fetch accurate time. Timer may be inaccurate.",
        //   color: "warning",
        //   variant: "bordered"
        // });
        setTimeOffset(0);
      }
    };

    fetchRealTime();

    const syncInterval = setInterval(fetchRealTime, 5 * 60 * 1000);

    return () => clearInterval(syncInterval);
  }, []);

  const calculateTimeLeft = () => {
    if (timeOffset === null) return null;

    const realNow = Date.now() + timeOffset;

    const targetTime =
      typeof date === "number" ? date : new Date(date).getTime();
    const difference = targetTime - realNow;

    if (difference <= 0) {
      return { completed: true };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / 1000 / 60) % 60);
    const seconds = Math.floor((difference / 1000) % 60);

    return { days, hours, minutes, seconds, completed: false };
  };

  const zeroPad = (num) => String(num).padStart(2, "0");

  // Use state to force re-render every second
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick(Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Also update when tab becomes visible again
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        setTick(Date.now());
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  if (timeOffset === null) return <span>Loading timer...</span>;

  const timeLeft = calculateTimeLeft();

  if (timeLeft.completed) {
    isSetTime(true);
    return <span>{new Date(date).toUTCString()}</span>;
  }

  return (
    <span>
      {zeroPad(timeLeft.days)}d {zeroPad(timeLeft.hours)}h{" "}
      {zeroPad(timeLeft.minutes)}m {zeroPad(timeLeft.seconds)}s
    </span>
  );
};

export default CountDownComponent;
